import styled from 'styled-components';

export const InfoValue = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
